// #region imports

import * as React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  FeedbackItem
} from '../../models';

import {
  MATERIALUI_DIALOG_REASON_BACKDROPCLICK,
  MATERIALUI_DIALOG_REASON_ESCKEYDOWN,
} from '../../global';

// UTC to local date formatting hooks
import { useDates } from '../../hooks/UseDates';

// #endregion

// #region interfaces

interface FeedbackDetailDialogProps {
  feedback: FeedbackItem;
  handleClose: () => void;
  show: boolean;
}

// #endregion

const FeedbackDetailDialog: React.FC<FeedbackDetailDialogProps> = (props) => {

  const { dateStringToLocalDateFormatted } = useDates();

  // #region Styles

  const theme = useTheme();
  const styles = {
    closeButton: {
      margin: theme.spacing(0, 1, 1, 0)
    },
    reported: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      margin: theme.spacing(0, 0, 1, 0)
    },
    title: {
      margin: theme.spacing(0, 0, 1, 0)
    },
  };

  // #endregion

  // #region Event handlers

  /*
* Event handler for Material-UI onClose
*/
  const handleClose = (event: object, reason: string) => {
    if ((reason === MATERIALUI_DIALOG_REASON_BACKDROPCLICK) || (reason === MATERIALUI_DIALOG_REASON_ESCKEYDOWN)) {
      return;
    }
  };

  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <Grid container>
          <Grid container size={12} sx={styles.reported}>
            <Typography variant="body2">{`${props.feedback.feedbackType.type}: ${dateStringToLocalDateFormatted(props.feedback.reported)} by: ${props.feedback.reportedBy}`}</Typography>
          </Grid>
          <Grid container size={12} sx={styles.title}>
            <Typography variant="body2">Title: {`${props.feedback.title}`}</Typography>
          </Grid>
          <Grid container size={12}>
            <Typography variant="body2"><span dangerouslySetInnerHTML={{ __html: props.feedback.description }}></span></Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} variant="outlined" color="primary" sx={styles.closeButton}>Close</Button>
      </DialogActions>
    </Dialog >
  );

}

export default FeedbackDetailDialog;